<div class="component-container flex flex-col h-full">
  <div class="details flex-1 overflow-y-auto">
    @if (changeOrderCreateMode === 'auto') {
      <app-text-input
        [parentFormGroup]="form"
        class="w-full my-[20px]"
        controlName="changeOrderNo"
        label="change Order No"
        />
    }
    @if (linkedRequests?.length) {
      <div class="flex flex-wrap gap-[8px] mt-[16px] mb-[20px] items-center">
        @for (cor of linkedRequests.slice(0, showAllLinkedRequests ? linkedRequests.length : 3); track cor.uuid) {
          <span class="linked-cor-badge flex items-center gap-[6px]">
            <span
              [matTooltip]="cor.request_no"
              matTooltipPosition="above"
              matTooltipClass="project-name-tooltip">
              Request #{{ shortRequestNo(cor.request_no) }}
            </span>
            @if (editable) {
              <mat-icon (click)="unlinkRequest(cor)" class="linked-cor-unlink cursor-pointer" matTooltip="Remove from change order" matTooltipPosition="above" matTooltipClass="project-name-tooltip">link_off</mat-icon>
            }
          </span>
        }
        @if (linkedRequests.length > 3 && !showAllLinkedRequests) {
          <span (click)="showAllLinkedRequests = true" class="linked-cor-more cursor-pointer">+{{ linkedRequests.length - 3 }} more</span>
        }
      </div>
    }
    <div
      class="count-section flex justify-center items-center gap-[15px] mb-[40px]">
      <div class="total-amount-change flex flex-col gap-[12px] w-1/2">
        <div class="label text-type-13 uppercase">
          Total Amount Change:
        </div>
        <div class="value text-type-8">
          ${{ totalAmount | number:'1.2-2' }}
        </div>
      </div>
      <div class="total-working-days flex flex-col gap-[12px] w-1/2">
        <div class="label text-type-13 uppercase">
          Total NEW Working Days:
        </div>
        <div class="value text-type-8">
          {{ totalNewWorkingDays }}
        </div>
      </div>
    </div>
    @if (displayError) {
      <div #displayErrorRef class="warning-banner mb-[20px]">
        <span class="warning-icon">&#9888;</span>
        <div class="warning-messages">
          @if (displayLineError) {
            <div>At least one line item is required.</div>
          }
          @if (displayTotalAmountError) {
            <div>Total exceeds the combined approved requests (${{ corTotalAmount | number:'1.2-2' }})</div>
          }
          @if (displayTotalNewWorkingDaysError) {
            <div>Working days exceed the combined approved requests ({{ corTotalDays }})</div>
          }
        </div>
      </div>
    }
    <div class="item-section flex flex-col gap-[20px] mb-[40px]">
      <div class="items-list flex flex-col gap-[40px]">
        <!-- Lines Accordion -->
        @if (lineKeys?.length) {
          @for (lineKey of lineKeys; track lineKey; let i = $index) {
            <div>
              <div [class.is-expanded]="selectedLineId === lineKey"
                [id]="lineKey"
                class="line-accordion border-[1px] border-[#C2C8DC] rounded-[4px] p-[16px]">
                <div class="line-header flex flex-col gap-[12px]">
                  <div class="line-accordion-heading text-type-13 uppercase flex justify-between items-center">
                    <div (click)="selectLine(lineKey)" class="heading-label cursor-pointer">
                      Item {{ i + 1 }}:
                    </div>
                    <div class="heading-action-section flex justify-center items-center gap-[20px]">
                      <mat-icon
                        (click)="selectLine(lineKey)"
                        [svgIcon]="selectedLineId === lineKey ? 'chevron-up' : 'chevron-down'"
                        class="accordion-icon chevron-icon cursor-pointer"
                        />
                      @if (editable && !isSourcedLine(lineKey)) {
                        <mat-icon
                          (click)="deleteLine(lineKey)"
                          [svgIcon]="'trash'"
                          class="accordion-icon delete-icon cursor-pointer"
                          />
                      }
                    </div>
                  </div>
                  <div class="line-accordion-sub-heading flex justify-between items-center w-full">
                    <span #subHeadingSpan
                      #subHeadingTooltip="matTooltip"
                      [matTooltip]="form?.controls[lineKey]?.['controls']?.['item']?.value"
                      [matTooltipDisabled]="true"
                      (mouseenter)="subHeadingTooltip.disabled = !isEllipsisActive(subHeadingSpan)"
                      matTooltipPosition="above"
                      matTooltipClass="project-name-tooltip"
                      class="truncate flex-1 min-w-0"
                      >
                      <span class="text-type-8">{{ form?.controls[lineKey]?.['controls']?.['itemNo']?.value }}</span><span class="text-type-10 ml-[6px] !normal-case">{{ form?.controls[lineKey]?.['controls']?.['desc']?.value | sentenceCase }}</span>
                    </span>
                    @if (lineSources[lineKey]) {
                      <span class="source-request-badge text-type-14"
                        [matTooltip]="'Change request ' + lineSources[lineKey].request_no + '. Remove the request from this change order to change it.'"
                        matTooltipPosition="above"
                        matTooltipClass="project-name-tooltip">
                        Request #{{ shortRequestNo(lineSources[lineKey].request_no) }}
                      </span>
                    }
                  </div>
                </div>
                <div class="line-content">
                  <app-change-orders-request-line-item
                    [class.hidden]="selectedLineId !== lineKey"
                    [formGroup]="getLineGroup(lineKey)"
                    [lineKey]="lineKey"
                    />
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="descriptionLengthError || errorMessages['descriptionOfChange']"
      [maxLength]="descriptionMaxLength"
      [showCharCount]="true"
      [parentFormGroup]="form"
      class="w-full mb-[10px]"
      controlName="descriptionOfChange"
      label="Description of Change"
      />
    <app-text-area
      [maxLength]="descriptionMaxLength"
      [parentFormGroup]="form"
      class="w-full mb-[10px]"
      controlName="location"
      label="Location"
      />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="false"
      [error]="errorMessages['subContractor']"
      [options]="subContractorOptions"
      [parentFormGroup]="form"
      class="w-full mb-[10px]"
      controlName="subContractor"
      label="sub Contractor"
      placeholder="Select"
      />
    @if (mediaFiles?.length) {
      <app-pictures-section
        (onDelete)="deletePicture($event)"
        [isEditable]="editable"
        [pictures]="mediaFiles"
        class="pictures-section mb-[40px] mt-[30px]"
        />
    }
  </div>

  <!-- Add + Save + Review Buttons -->
  @if ((!data?.id || data?.status === 'draft' || data?.status === 'rejected') && data?.status !== 'approved') {
    @if (changeOrderCreateMode !== 'auto' && data?.status === 'draft') {
      <div
        (click)="availableCorCount > 0 && openAddRequestDialog()"
        [class.disabled-link]="availableCorCount === 0"
        class="add-item text-type-9 mt-[16px] mb-[20px]"
        [class.cursor-pointer]="availableCorCount > 0"
      >
        <span>Add request <span class="text-type-14">({{ availableCorCount }} available)</span></span>
      </div>
    }
    <div
      class="action-section flex gap-[20px] pb-[10px] pl-[4px] w-full justify-center items-center flex-shrink-0 bg-white pt-[16px] border-t border-[#E9ECF4]"
      >
      <div [matMenuTriggerFor]="add" class="action-button add-button">
        <mat-icon class="add" svgIcon="plus"></mat-icon>
      </div>
      <app-secondary-button
        (handleClick)="save()"
        [isDisabled]="!isFormDirty"
        class="save-btn w-full flex-1"
        >
        Save
      </app-secondary-button>
      <app-primary-button
        (handleClick)="submit()"
        class="submit-btn w-full flex-1"
        >
        Review
      </app-primary-button>
    </div>
  } @else {
    <div
      class="action-section flex gap-[20px] pb-[10px] pl-[4px] w-full justify-center items-center flex-shrink-0 bg-white pt-[16px] border-t border-[#E9ECF4]"
      >
      <app-primary-button
        (handleClick)="submit()"
        class="w-full flex-1 workflow-btn"
        >
        Review
      </app-primary-button>
    </div>
  }
</div>

<input
  #fileInput
  (change)="onFileSelected($event)"
  class="hidden"
  multiple="multiple"
  type="file" />
<mat-menu #add="matMenu">
  @for (option of addMenuOptions; track option) {
    <button
      (click)="option.handler()"
      mat-menu-item
      >
      <div class="add-menu-item flex justify-start items-center">
        <div class="flex justify-center items-center h-[48px]">
          <mat-icon [svgIcon]="option.icon" class="menu-icon" />
        </div>
        <div class="menu-label">{{ option.label }}</div>
      </div>
    </button>
  }
</mat-menu>
